import { useRef } from "react";
import CalculRow from "./CalculRow";
import useScrollOnDrag from "react-scroll-ondrag";
import { SORT_CALCUL_MODIFIED_AT_DESC } from "../../../common/constants/sort";
import { MFCheckbox } from "../../../common/components/MFCheckbox";
import { CalculTableHeaders } from "./utils/CalculTableHeaders";
import {
  DOWNLOADXLS,
  DOWNLOADXMLCONFIG,
  DOWNLOADXMLINIES,
} from "../../fdes/constants/metadata";
import { FINISHED } from "../constants";

const CalculsTable = ({
  user,
  deleteCalcul,
  duplicateCalcul,
  calculs,
  changeCalculsSort,
  isGeneratingReports,
  generatingReportsIds,
  calculsSort,
  generateReports,
  aggregatedFamilyProducts,
  getFdesMetadataCalculRow,
  sendXmlToEDEC,
  localEDECIntegration,
  folders,
  createFolder,
  tableScrollDisabled,
  setCalculArchived,
  updateCalculAttributes,
  calculsColumns,
  selectedCalculs,
  setSelectedCalculs,
}) => {
  // const [isDragging, setIsDragging] = useState(false);
  const ref = useRef();
  const { events } = useScrollOnDrag(ref, {
    // onDragStart: () => setIsDragging(true),
    // onDragEnd: () => setIsDragging(false),
  });
  const selectedCalculsOnThisPage = calculs
    .filter((calcul) => selectedCalculs.map((c) => c.id).includes(calcul._id))
    .map((calcul) => calcul._id);

  function handleSort(sortAsc, sortDesc) {
    if (calculsSort === sortAsc) {
      changeCalculsSort(sortDesc);
    } else if (
      calculsSort === sortDesc &&
      calculsSort !== SORT_CALCUL_MODIFIED_AT_DESC
    ) {
      changeCalculsSort(SORT_CALCUL_MODIFIED_AT_DESC);
    } else {
      changeCalculsSort(sortAsc);
    }
  }

  function handleSelectAll() {
    if (selectedCalculsOnThisPage.length === calculs.length) {
      setSelectedCalculs(
        selectedCalculs.filter(
          (c) => !selectedCalculsOnThisPage.includes(c.id),
        ),
      );
    } else {
      setSelectedCalculs([
        ...selectedCalculs.filter(
          (c) => !calculs.some((calcul) => calcul._id === c.id),
        ),
        ...calculs.map((calcul) => {
          const downloadXml =
            calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXMLCONFIG)
              ?.visible ?? false;
          const downloadXmlInies =
            calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXMLINIES)
              ?.visible ?? false;
          const downloadXls =
            calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXLS)
              ?.visible ?? false;

          return {
            id: calcul._id,
            name: calcul.title,
            isDuplicable: !!calcul.isCompatible,
            isFinished: calcul.status === FINISHED,
            isRestorable: false,
            simulationMode: calcul?.options?.simulationMode === true,
            folderIds: calcul.folders?.map((f) => f._id) || [],
            outputs: [
              "pdf",
              ...(downloadXml ? ["xml"] : []),
              ...(downloadXmlInies ? ["inies"] : []),
              ...(downloadXls ? ["xls"] : []),
            ],
          };
        }),
      ]);
    }
  }

  return (
    <div
      ref={ref}
      onMouseDown={tableScrollDisabled ? undefined : events.onMouseDown}
      className="d-block tableFixHead"
      style={{
        userSelect: "none",
        // cursor: isDragging ? "grabbing" : "grab",
      }}
    >
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="selection-column">
              <MFCheckbox
                checked={
                  selectedCalculsOnThisPage.length > 0 &&
                  selectedCalculsOnThisPage.length === calculs.length
                }
                onChange={handleSelectAll}
              />
            </th>
            <CalculTableHeaders
              calculsColumns={calculsColumns}
              handleSort={handleSort}
              sort={calculsSort}
            />
            {selectedCalculs.length === 0 && (
              <th className="px-1 actions-column">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {calculs &&
            calculs.length > 0 &&
            calculs.map((calcul) => (
              <CalculRow
                key={calcul._id}
                user={user}
                isGeneratingReports={isGeneratingReports}
                generatingReportsIds={generatingReportsIds}
                deleteCalcul={deleteCalcul}
                duplicateCalcul={duplicateCalcul}
                calcul={calcul}
                generateReports={generateReports}
                aggregatedFamilyProducts={aggregatedFamilyProducts}
                getFdesMetadataCalculRow={getFdesMetadataCalculRow}
                sendXmlToEDEC={sendXmlToEDEC}
                localEDECIntegration={localEDECIntegration}
                folders={folders}
                createFolder={createFolder}
                setCalculArchived={setCalculArchived}
                updateCalculAttributes={updateCalculAttributes}
                calculsColumns={calculsColumns}
                selectedCalculs={selectedCalculs}
                setSelectedCalculs={setSelectedCalculs}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default CalculsTable;
